import { PagenatedResponse } from '@models/common';
import { CustomerBenefitEventItem, Feed, FeedData, FeedDataItem } from '@models/feed';
import { ProductModel, ProductSearchQuery } from '@models/product';
import { apiClient } from '.';

export const searchFeedLogs = async (query?: ProductSearchQuery) => {
  return apiClient.get<PagenatedResponse<ProductModel>>(`/admin/v1/feed/logs`, {
    params: query,
  });
};

export const getFeed = async (type: 'main-feed' | 'md-pick') => {
  return apiClient.get<Feed<FeedDataItem>>(`/admin/v1/feed/${type}`);
};

export const refreshMainFeed = async () => {
  return apiClient.post(`/admin/v1/schedule/refresh-mainfeed`);
};

export const updateMainFeed = async (formData: FormData) => {
  return apiClient.put(`/admin/v1/feed/main-feed`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const updateMdPick = async (formData: FormData) => {
  return apiClient.put(`/admin/v1/feed/md-pick`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deployFeed = async (type: 'main-feed' | 'md-pick') => {
  return apiClient.post<Feed<FeedDataItem>>(`/admin/v1/feed/${type}/deploy`);
};

export const getBanners = async () => {
  return apiClient.get<Feed<FeedDataItem>>(`/admin/v1/feed/banners`);
};

export const updateBanners = async (formData: FormData) => {
  return apiClient.put(`/admin/v1/feed/banners`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const getFeedElements = async () => {
  return apiClient.get<{
    searchPlaceholder?: Feed<FeedDataItem>;
    popularKeywords?: Feed<FeedDataItem>;
    recommendKeywords?: Feed<FeedDataItem>;
    chatIntroWarnings?: Feed<FeedDataItem>;
    loungeCurationCategories?: Feed<FeedDataItem>;
    bottomTabbarTooltips?: Feed<FeedDataItem>;
  }>(`/admin/v1/feed/elements`);
};

export const updateFeedElements = async (body: {
  searchPlaceholder?: Feed<FeedDataItem>;
  popularKeywords?: Feed<FeedDataItem>;
  recommendKeywords?: Feed<FeedDataItem>;
  chatIntroWarnings?: Feed<FeedDataItem>;
  loungeCurationCategories?: Feed<FeedDataItem>;
  bottomTabbarTooltips?: Feed<FeedDataItem>;
}) => {
  return apiClient.put(`/admin/v1/feed/elements`, body);
};

export const getCustomerBenefitEvents = async () => {
  const response = await apiClient.get<FeedData<CustomerBenefitEventItem>>('/admin/v1/feed/customer-benefit-events');
  return response.data;
};

export const updateCustomerBenefitEvent = async (formData: FormData) => {
  return apiClient.put<FeedData<CustomerBenefitEventItem>>(`/admin/v1/feed/customer-benefit-events`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
